module.exports = __webpack_public_path__ + "static/media/irregularShape1.a3970daa.jpg";